/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BonusAccountEnumItem
 */
export interface BonusAccountEnumItem {
    /**
     * 编码
     * @type {number}
     * @memberof BonusAccountEnumItem
     */
    code?: number;
    /**
     * 名称（根据语言环境返回）
     * @type {string}
     * @memberof BonusAccountEnumItem
     */
    name?: string;
}

/**
 * Check if a given object implements the BonusAccountEnumItem interface.
 */
export function instanceOfBonusAccountEnumItem(value: object): value is BonusAccountEnumItem {
    return true;
}

export function BonusAccountEnumItemFromJSON(json: any): BonusAccountEnumItem {
    return BonusAccountEnumItemFromJSONTyped(json, false);
}

export function BonusAccountEnumItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): BonusAccountEnumItem {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'name': json['name'] == null ? undefined : json['name'],
    };
}

export function BonusAccountEnumItemToJSON(json: any): BonusAccountEnumItem {
    return BonusAccountEnumItemToJSONTyped(json, false);
}

export function BonusAccountEnumItemToJSONTyped(value?: BonusAccountEnumItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'name': value['name'],
    };
}

